import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import axios from "axios";
import { CookieSetting } from "cookiesetting-component";
import jsonData from "./ai-branding.json";

const Footer = lazy(() => import("./components/Footerupdated/Footer.js"));
const Proprty = lazy(() => import("./components/Property/proprty.js"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const Morganlogos = lazy(() => import("./components/Morganlogos/Morganlogos.js"));
const Whysunwest = lazy(() => import("./components/Whysunwest/Morganscan.js"));

function App() {
  const [isMobile, setIsMobile] = useState();
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [propertyData, setPropertyData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();

  useEffect(() => {
    const fetchMorganWebinarJSON = async () => {
      await axios.get(process.env.REACT_APP_MASTERMINDJSON_CDN_URL)
        .then(response => {
          const webinarJsonData = response.data;
          setWebinarData(webinarJsonData);
          setBannerData(webinarJsonData.banner);
          setHighlightsData(webinarJsonData.highlights);
          setPropertyData(webinarJsonData.property);
          setTimerData(webinarJsonData.countdown);
          setFormData(webinarJsonData.signupform);
        }, error => {
          console.log(error);
        });

    };
    fetchMorganWebinarJSON();
  }, []);

  const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }

    if (window.innerWidth>=768) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }, []);

  return (
    <div className="bodyContainer">
      <Header isMobile={isMobile} fetchpriority="high" />
      {bannerData ?
        <>
          <Body bannerData={bannerData} timerData={timerData} formData={formData} links={links} isMobile={isMobile} fetchpriority="high" />
          <Suspense fallback={<div />}>
            {highlightsData ?
              <Highlights highlightsData={highlightsData} links={links} />
              : ""}
          </Suspense>
          <Suspense fallback={<div />}>
            {propertyData ?
              <Proprty propertyData={propertyData} />
              : ""}
          </Suspense>
          <Suspense fallback={<div />}>
            <Morganlogos />
          </Suspense>
          <Suspense fallback={<div />}>
            <Whysunwest />
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
          <CookieSetting 
            privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
            configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
            analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </>
        : ""}
    </div>
  );
}

export default App;
